import React, { useState, useEffect } from "react";
import { BiHomeAlt, BiUser } from "react-icons/bi";
import { BsBriefcase, BsChatSquareText, BsClipboardData } from "react-icons/bs";
import { Link } from "react-scroll";

const Nav = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "py-2 md:py-4" : "py-3 md:py-6"
      }`}
    >
      <div className="container mx-auto">
        <div
          className={`flex items-center justify-between px-4 md:px-6 lg:px-8 py-3 md:py-4 bg-white/95 backdrop-blur-sm border border-stone/30 transition-all duration-300 ${
            scrolled ? "shadow-elegant-lg" : "shadow-elegant"
          }`}
        >
          {/* Logo */}
          <Link
            to="home"
            smooth={true}
            spy={true}
            offset={-100}
            className="font-primary font-bold text-2xl lg:text-3xl cursor-pointer bg-gradient-to-r from-gold via-gold-rose to-terracotta bg-clip-text text-transparent hover:opacity-80 transition-opacity"
          >
            AR.
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-2">
            <Link
              to="home"
              activeClass="bg-gradient-to-r from-gold to-gold-rose text-white shadow-elegant"
              smooth={true}
              spy={true}
              offset={-100}
              className="px-6 py-3 font-primary font-medium cursor-pointer border border-transparent hover:bg-sand-light/50 transition-all hover:-translate-y-0.5"
            >
              Accueil
            </Link>
            <Link
              to="about"
              activeClass="bg-gradient-to-r from-gold to-gold-rose text-white shadow-elegant"
              smooth={true}
              spy={true}
              offset={-50}
              className="px-6 py-3 font-primary font-medium cursor-pointer border border-transparent hover:bg-sand-light/50 transition-all hover:-translate-y-0.5"
            >
              À propos
            </Link>
            <Link
              to="services"
              activeClass="bg-gradient-to-r from-gold to-gold-rose text-white shadow-elegant"
              smooth={true}
              spy={true}
              offset={-50}
              className="px-6 py-3 font-primary font-medium cursor-pointer border border-transparent hover:bg-sand-light/50 transition-all hover:-translate-y-0.5"
            >
              Compétences
            </Link>
            <Link
              to="work"
              activeClass="bg-gradient-to-r from-gold to-gold-rose text-white shadow-elegant"
              smooth={true}
              spy={true}
              offset={-50}
              className="px-6 py-3 font-primary font-medium cursor-pointer border border-transparent hover:bg-sand-light/50 transition-all hover:-translate-y-0.5"
            >
              Projets
            </Link>
            <Link
              to="contact"
              activeClass="bg-gradient-to-r from-gold to-gold-rose text-white shadow-elegant"
              smooth={true}
              spy={true}
              offset={-50}
              className="px-6 py-3 font-primary font-medium cursor-pointer bg-navy text-white border border-navy shadow-elegant hover:shadow-elegant-hover hover:-translate-y-1 transition-all"
            >
              Contact
            </Link>
          </div>

          {/* Mobile Navigation */}
          <div className="flex md:hidden items-center gap-1 text-xl">
            <Link
              to="home"
              activeClass="bg-gradient-to-br from-gold to-gold-rose text-white shadow-elegant"
              smooth={true}
              spy={true}
              offset={-100}
              className="w-12 h-12 flex items-center justify-center cursor-pointer border border-stone/40 hover:bg-sand-light/50 hover:border-gold/50 transition-all"
            >
              <BiHomeAlt />
            </Link>
            <Link
              to="about"
              activeClass="bg-gradient-to-br from-gold to-gold-rose text-white shadow-elegant"
              smooth={true}
              spy={true}
              offset={-50}
              className="w-12 h-12 flex items-center justify-center cursor-pointer border border-stone/40 hover:bg-sand-light/50 hover:border-gold/50 transition-all"
            >
              <BiUser />
            </Link>
            <Link
              to="services"
              activeClass="bg-gradient-to-br from-gold to-gold-rose text-white shadow-elegant"
              smooth={true}
              spy={true}
              offset={-50}
              className="w-12 h-12 flex items-center justify-center cursor-pointer border border-stone/40 hover:bg-sand-light/50 hover:border-gold/50 transition-all"
            >
              <BsClipboardData />
            </Link>
            <Link
              to="work"
              activeClass="bg-gradient-to-br from-gold to-gold-rose text-white shadow-elegant"
              smooth={true}
              spy={true}
              offset={-50}
              className="w-12 h-12 flex items-center justify-center cursor-pointer border border-stone/40 hover:bg-sand-light/50 hover:border-gold/50 transition-all"
            >
              <BsBriefcase />
            </Link>
            <Link
              to="contact"
              activeClass="bg-gradient-to-br from-gold to-gold-rose text-white shadow-elegant"
              smooth={true}
              spy={true}
              offset={-50}
              className="w-12 h-12 flex items-center justify-center cursor-pointer border border-navy bg-navy text-white hover:border-navy-dark hover:bg-navy-dark transition-all"
            >
              <BsChatSquareText />
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Nav;
